import { apply, diff } from "@scalar/json-magic/diff";
import { split } from "../helpers/general.js";
const excludeKeys = /* @__PURE__ */ new Set(["x-scalar-navigation", "x-ext", "x-ext-urls", "$status"]);
const applySelectiveUpdates = (originalDocument, updatedDocument) => {
  const diffs = diff(originalDocument, updatedDocument);
  const [writableDiffs, excludedDiffs] = split(diffs, (d) => !d.path.some((p) => excludeKeys.has(p)));
  apply(originalDocument, writableDiffs);
  return [originalDocument, excludedDiffs];
};
export {
  applySelectiveUpdates
};
//# sourceMappingURL=apply-selective-updates.js.map
